import type { OneToTen, ScaleSelectorProps } from "@qendo/profile/journal";
import { ScaleType } from "@qendo/trackables";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RangeInput } from "~/components/form/RangeInput";

export type OneToTenSelectorProps = ScaleSelectorProps<ScaleType.ten>;

const clamp = (input: number | null | undefined): OneToTen | 0 => {
    return Math.max(0, Math.min(10, Math.abs(input ?? 0))) as OneToTen | 0;
};

export const OneToTenSelector = ({ value, onUpdateScale, zIndex, ...rangeProps }: OneToTenSelectorProps) => {
    const scale = clamp(value?.value);

    const changeScale = (val: number) => {
        scale !== val &&
            onUpdateScale({
                type: ScaleType.ten,
                value: val === 0 ? null : (clamp(val) as OneToTen),
            });
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <RangeInput {...rangeProps} min={1} max={10} step={1} value={scale} onValueChange={changeScale} />
        </FieldGroup>
    );
};
